import { render, staticRenderFns } from "./UsedGunReport.vue?vue&type=template&id=e156746a&scoped=true"
import script from "./UsedGunReport.vue?vue&type=script&lang=js"
export * from "./UsedGunReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e156746a",
  null
  
)

export default component.exports